export default {
	text: {
		marginLeft: 15,
	},
};
